import { DataService } from "./data-service";
import { IPage } from "../entities/page";
import { EnterpriseUserUpdateRequest, IEnterpriseUser, IEnterpriseUserRequestParams } from "../entities/enterprise-user";

class EnterpriseUserService extends DataService {
    constructor() {
        super("account/enterprise-user", 2);
    }

    getPage(requestParams: IEnterpriseUserRequestParams): Promise<IPage<IEnterpriseUser>> {
        return this.api.get<IPage<IEnterpriseUser>>(null, requestParams);
    }

    revertUserAccountToIndividual(userId: string): Promise<void> {
        return this.api.delete(userId);
    }

    updateUser(userId: string, request: EnterpriseUserUpdateRequest): Promise<IEnterpriseUser> {
        return this.api.put<IEnterpriseUser>(userId, request);
    }
}

export const enterpriseUserService = new EnterpriseUserService();
